import { GsbEntityDef, GsbProperty } from './gsb-entity-def.model';
import { GsbFile } from './gsb-file.model';
import { GsbWfFunction, OperationType } from './gsb-function.model';
import { GsbModule } from './gsb-module.model';
import { SubscriptionType } from './gsb-subscription.model';
import { GsbWorkflow } from './gsb-workflow.model';

/**
 * Represents a GSB User entity
 */
export class GsbUser {
  _entDefName?: string;
  id?: string;
  name?: string;
  variation?: any;
  token?: string;
  picture?: GsbFile;
  picture_id?: string;
  surname?: string;
  email?: string;
  createDate?: Date;
  lastUpdateDate?: Date;
  createdBy_id?: string;
  lastUpdatedBy_id?: string;
  title?: string;
  birthDate?: Date;
  constructor(obj?: Partial<GsbUser>) {
      Object.assign(this, obj);
      this._entDefName = "GsbUser";
  }
}

/**
 * Represents a GSB Role entity
 */
export class GsbRole {
  _entDefName?: string;
  id?: string;
  name?: string;
  users?: GsbUser[];
  createDate?: Date;
  lastUpdateDate?: Date;
  createdBy_id?: string;
  lastUpdatedBy_id?: string;

  constructor(obj?: Partial<GsbRole>) {
      Object.assign(this, obj);
      this._entDefName = "GsbRole";
  }
}


/**
 * Represents a contact in the system
 */
export class GsbContact {
  _entDefName?: string;
  id?: string;
  name?: string;
  email?: string;
  phone?: string;
  address?: string;
  createDate?: Date;
  lastUpdateDate?: Date;
  createdBy_id?: string;
  lastUpdatedBy_id?: string;

  constructor(obj?: Partial<GsbContact>) {
      Object.assign(this, obj);
      this._entDefName = "GsbContact";
  }
}

/**
 * Represents a user group in the system
 */
export class GsbGroup {
  _entDefName?: string;
  id?: string;
  name?: string;
  description?: string;
  createDate?: Date;
  lastUpdateDate?: Date;
  createdBy_id?: string;
  lastUpdatedBy_id?: string;

  constructor(obj?: Partial<GsbGroup>) {
      Object.assign(this, obj);
      this._entDefName = "GsbGroup";
  }
}


/**
 * Represents a GSB Position entity
 */
export class GsbPosition {
  _entDefName?: string;
  id?: string;
  name?: string;
  departments?: string[];
  users?: string[] | GsbUser[];
  roles?: string[] | GsbRole[];
  defaultDepartment_id?: string;
  defaultDepartment?: GsbDepartment;
  tanent_id?: string;
  createDate?: Date;
  lastUpdateDate?: Date;
  createdBy_id?: string;
  lastUpdatedBy_id?: string;

  constructor(obj?: Partial<GsbPosition>) {
      Object.assign(this, obj);
      this._entDefName = "GsbPosition";
  }
}

/**
 * Represents a GSB Department entity
 */
export class GsbDepartment {
  _entDefName?: string;
  id?: string;
  name?: string;
  positions?: string[] | GsbPosition[];
  defaultPosition?: GsbPosition;
  createDate?: Date;
  lastUpdateDate?: Date;
  createdBy_id?: string;
  lastUpdatedBy_id?: string;

  constructor(obj?: Partial<GsbDepartment>) {
      Object.assign(this, obj);
      this._entDefName = "GsbDepartment";
  }
}

/**
 * Represents the type of permission
 */
export enum GsbPermissionType {
  Read = 1,
  Create = 2,
  Delete = 4,
  Edit = 8,
  Query = 16,
  Execute = 32
}

export class GsbPermission {
  _entDefName?: string;
  positions?: GsbPosition[];
  //pages?: GsbPage[];
  nestedOnly?: boolean;
  subscriptionType?: SubscriptionType;
  priority?: number;
  workflows?: GsbWorkflow[];
  disablePaging?: boolean;
  queryCountLimit?: number;
  functions?: GsbWfFunction[];
  modules?: GsbModule[];
  description?: string;
  entPropDefaults?: GsbEntityDef[];
  groups?: GsbGroup[];
  entityDefReads?: GsbEntityDef[];
  module_id?: string;
  createDate?: Date;
  queryStr?: string;
  trackVersion?: string;
  departments?: GsbDepartment[];
  id?: string;
  createdBy_id?: string;
  lastUpdatedBy?: GsbUser;
  permissionType?: OperationType;
  title?: string;
  limitReachBy?: string;
  lastUpdateDate?: Date;
  module?: GsbModule;
  users?: GsbUser[];
  entityDef?: GsbEntityDef[];
  name?: string;
  createdBy?: GsbUser;
  properties?: GsbProperty[];
  lastUpdatedBy_id?: string;
  roles?: GsbRole[];

  constructor(obj?: Partial<GsbPermission>) {
      Object.assign(this, obj);
      this._entDefName = "GsbPermission";
  }
}




/**
 * Represents a GSB Position Token
 */
export class GsbPosToken {
  _entDefName?: string;
  jwtToken?: string;
  positionName?: string;

  constructor(obj?: Partial<GsbPosToken>) {
      Object.assign(this, obj);
      this._entDefName = "GsbPosToken";
  }
}
